module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.cd1373d6.svg";